var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.css,attrs:{"src":_vm.selectedImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }